function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m53.85 26.732h-33.7a2.283 2.283 0 0 1 -2.28-2.279v-2.464a2.283 2.283 0 0 1 2.28-2.281h33.7a2.283 2.283 0 0 1 2.28 2.281v2.464a2.283 2.283 0 0 1 -2.28 2.279zm-33.7-5.024a.281.281 0 0 0 -.28.281v2.464a.28.28 0 0 0 .28.279h33.7a.28.28 0 0 0 .28-.279v-2.464a.281.281 0 0 0 -.28-.281z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m52.837 21.712h-31.674a1 1 0 0 1 -1-1.031 16.778 16.778 0 0 1 12.167-15.63 1 1 0 0 1 .555 1.922 14.783 14.783 0 0 0 -10.655 12.739h29.54a14.783 14.783 0 0 0 -10.655-12.739 1 1 0 0 1 .555-1.922 16.778 16.778 0 0 1 12.166 15.63 1 1 0 0 1 -1 1.031z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m40.388 14.085a.976.976 0 0 1 -.142-.009 1 1 0 0 1 -.85-1.131l1.215-8.566a.332.332 0 0 0 -.329-.379h-6.564a.332.332 0 0 0 -.329.38l1.211 8.565a1 1 0 1 1 -1.981.281l-1.211-8.566a2.333 2.333 0 0 1 2.31-2.66h6.564a2.333 2.333 0 0 1 2.31 2.659l-1.215 8.567a1 1 0 0 1 -.989.859z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m37 48.477a10.733 10.733 0 0 1 -5.824-1.714c-4.554-2.942-9.983-7.932-9.983-15v-6.031a1 1 0 0 1 1-1h29.614a1 1 0 0 1 1 1v6.033c0 7.066-5.429 12.056-9.983 15a10.733 10.733 0 0 1 -5.824 1.712zm-13.807-21.745v5.033c0 6.166 4.932 10.646 9.069 13.318a8.748 8.748 0 0 0 9.476 0c4.137-2.672 9.069-7.152 9.069-13.318v-5.033z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m64.229 72h-54.458a1 1 0 0 1 -1-1 23.281 23.281 0 0 1 19.356-23.012 1 1 0 0 1 .816.222 31.327 31.327 0 0 0 3.194 2.356 8.966 8.966 0 0 0 9.728 0 31.362 31.362 0 0 0 3.192-2.355.993.993 0 0 1 .816-.222 23.279 23.279 0 0 1 19.356 23v.011a1 1 0 0 1 -1 1zm-53.435-2h52.412a21.275 21.275 0 0 0 -17.223-19.958 34.107 34.107 0 0 1 -3.03 2.2 10.978 10.978 0 0 1 -11.9 0 34.058 34.058 0 0 1 -3.032-2.2 21.275 21.275 0 0 0 -17.227 19.958z"
});

var SvgOperator = function SvgOperator(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "line_icons",
    height: 512,
    viewBox: "0 0 74 74",
    width: 512,
    "data-name": "line icons",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOperator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/operator.90ad8157.svg";
export { ForwardRef as ReactComponent };